<template>
    <div class="form-group" :class="className">
        <label :for="id">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <b-form-input :id="id" :value="modelValue" @input="onInput" :type="type" class="form-control"
            :class="validation && validation.length > 0 ? 'is-invalid' : ''" :placeholder="placeholder" />
        <a v-if="isHelperLink" :href="helperLinkHref" class="text-primary " target="_blank" style="font-size: 12px;">
            {{ helperLinkText }}
        </a>
        <small v-if="validation && validation.length > 0" class="text-danger">
            {{ validation.join(', ') }}
        </small>
    </div>
</template>

<script>
import {
    BFormInput,
} from 'bootstrap-vue'
import { helper } from 'echarts/lib/export';

export default {
    components: {
        BFormInput,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
        },
        validation: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        required: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String
        },
        isHelperLink: {
            type: Boolean,
            default: false
        },
        helperLinkText: {
            type: String,
            default: null
        },
        helperLinkHref: {
            type: String,
            default: null
        }
    },
    methods: {
        onInput(e) {
            this.$emit("input", e)
        }
    },
};
</script>
